const loadFonts = async (fonts) => {
    if (Array.isArray(fonts) && fonts.length > 0) {
      const validFonts = fonts.filter(font => {
        if (font && typeof font.name === 'string' && typeof font.url === 'string') {
          try {
            new URL(font.url);
            return true;
          } catch (e) {
            return false;
          }
        }
        return false;
      });

      const uniqueFonts = Array.from(new Map(validFonts.map(font => [font.url, font])).values());

      if (uniqueFonts.length > 0) {
        await Promise.all(
          uniqueFonts.map(async font => {
            try {
              const fontFace = new FontFace(font.name, `url(${font.url})`);
              document.fonts.add(fontFace);
              await fontFace.load();
            } catch (error) {
              if (process.env.NODE_ENV !== 'production') {
                console.error(`Failed to load font: ${font.name}`, error);
              }
            }
          })
        );
      }
    }
};

export default loadFonts;
